/* PEACEPUPIL — comportements du thème : menu mobile, tiroir panier, fiche produit. */
(function () {
  'use strict';

  var R = (window.PP && window.PP.routes) || {};
  var S = (window.PP && window.PP.strings) || {};
  var body = document.body;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Menu mobile ---------- */
  var navToggle = $('[data-nav-toggle]');
  var nav = $('#site-nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Tiroir panier ---------- */
  var drawer = $('[data-drawer]');
  var veil = $('[data-drawer-veil]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = R.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    var c = $('[data-drawer-close]', drawer);
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (!drawer) return; // page panier : on laisse la page faire
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    }
    if (e.target.closest('[data-drawer-close]') || e.target === veil) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (!body.classList.contains('drawer-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab' && drawer) {
      var f = $$('a[href], button:not([disabled]), input:not([disabled])', drawer).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (s) { s.textContent = n; });
    var label = $('[data-drawer-count]');
    if (label) label.textContent = n === 1 ? S.oneItem : String(S.manyItems || '').replace('{{ count }}', n);
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var nb = $('[data-drawer-body]', doc), nf = $('[data-drawer-foot]', doc);
        var ob = $('[data-drawer-body]', drawer), of = $('[data-drawer-foot]', drawer);
        if (nb && ob) ob.innerHTML = nb.innerHTML;
        if (nf && of) { of.innerHTML = nf.innerHTML; of.hidden = nf.hasAttribute('hidden'); }
        return fetch(R.cartJs, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { window.location.href = R.cart || '/cart'; });
  }

  function changeLine(line, quantity) {
    var scope = drawer || $('[data-cart-page]');
    if (scope) scope.classList.add('is-loading');
    return fetch(R.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10) || 0) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshDrawer();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { if (scope) scope.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (btn) { e.preventDefault(); changeLine(btn.getAttribute('data-line-index'), btn.getAttribute('data-line-qty')); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.getAttribute('data-line-index'), input.value);
  });

  /* ---------- Fiche produit ---------- */
  var section = $('[data-product-section]');
  if (section) initProduct(section);

  function initProduct(sec) {
    var form = $('[data-pdp-form]', sec);
    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add]', form);
    var addLabel = $('[data-add-label]', form);
    var errBox = $('[data-form-error]', sec);
    var priceEl = $('[data-price]', sec);
    var qty = $('[data-qty]', form);
    var jsonEl = $('[data-variants-json]', sec);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }
    var slides = $$('.pdp__slide', sec);
    var thumbs = $$('[data-thumb]', sec);
    var stickyPrice = $('[data-sticky-price]');
    var stickyBtn = $('[data-sticky-btn]');
    var addText = addLabel ? addLabel.getAttribute('data-add-text') : null;
    var textAdd = addLabel ? (addLabel.textContent.trim() || 'Ajouter au panier') : 'Ajouter au panier';
    if (!textAdd || /indisponible/i.test(textAdd)) textAdd = 'Ajouter au panier';

    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-media-id') === String(id);
        s.hidden = !on;
        if (on) found = true;
      });
      if (!found) { slides.forEach(function (s, i) { s.hidden = i !== 0; }); }
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
    }

    /* Les variantes n'ont pas toujours d'image associée dans l'admin : à défaut, on cherche
       l'image dont le texte alternatif contient la valeur de l'option choisie. */
    function mediaForVariant(v) {
      if (v.media_id) return v.media_id;
      var values = v.options.map(function (o) { return String(o).toLowerCase(); });
      for (var i = 0; i < slides.length; i++) {
        var alt = slides[i].getAttribute('data-alt') || '';
        for (var j = 0; j < values.length; j++) {
          if (values[j] && values[j] !== 'default title' && alt.indexOf(values[j]) !== -1) return slides[i].getAttribute('data-media-id');
        }
      }
      return null;
    }

    function selectedOptions() {
      return $$('.opt-group', form).map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }

    function currentVariant() {
      var sel = selectedOptions();
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }

    function setAvailability(v) {
      var ok = !!(v && v.available);
      if (addBtn) addBtn.disabled = !ok;
      if (stickyBtn) stickyBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = ok ? textAdd : 'Indisponible';
    }

    function onOptionChange() {
      $$('.opt-group', form).forEach(function (g) {
        var c = $('input:checked', g);
        var lbl = $('[data-option-label]', g);
        if (c && lbl) lbl.textContent = '— ' + c.value.charAt(0).toUpperCase() + c.value.slice(1);
      });
      var v = currentVariant();
      if (!v) { setAvailability(null); return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      setAvailability(v);
      showMedia(mediaForVariant(v));
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    $$('.opt-group input', form).forEach(function (i) { i.addEventListener('change', onOptionChange); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    // Coloris présélectionné par l'URL (?variant=) : montrer son image dès le chargement.
    var v0 = currentVariant();
    if (v0) { var m0 = mediaForVariant(v0); if (m0 && variants.length > 1) showMedia(m0); }

    /* Quantité */
    var dec = $('[data-qty-dec]', form), inc = $('[data-qty-inc]', form);
    if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { qty.value = Math.min(9, (parseInt(qty.value, 10) || 1) + 1); });

    /* Ajout au panier, sans quitter la page */
    form.addEventListener('submit', function (e) {
      if (!drawer) return; // pas de tiroir : envoi classique
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      if (errBox) errBox.hidden = true;
      if (addBtn) addBtn.classList.add('is-loading');
      var data = new FormData(form);
      fetch(R.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || S.error);
          return refreshDrawer().then(openDrawer);
        })
        .catch(function (err) {
          if (errBox) { errBox.textContent = err.message || S.error; errBox.hidden = false; }
        })
        .then(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
    });

    /* Barre d'achat fixe (mobile) : visible quand la zone d'achat sort de l'écran */
    var sticky = $('[data-sticky-buy]');
    var row = $('[data-buy-row]', sec);
    if (sticky && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
      }).observe(row);
    }
  }
})();
